<template>
    <div class="main-content file-log" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-8 col-6">
                    <h2>Daily Bids</h2>
                    </div>
                    <div class="col-lg-4 col-6 text-right bid">
                    <!-- <button  type="button" class="btn btn-success"><i class="fas fa-user-plus"></i> ADD NEW CUSTOMER</button>
                    <button type="button" class="btn btn-info"><i class="fas fa-file"></i> IMPORT DATA</button> -->
                    <!-- <button type="button" @click="exportToExcel()" class="btn btn-warning rounded ml-1"> <i class="fas fa-download"></i> EXPORT</button> -->
                    <!-- <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                        <i @click="searchLog()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchLog" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                    </form>               -->
                    </div>
                </div>
                
            </div>
            </div>
        </div>
         <div class="container-fluid mt--6 filter-show">
            <div class="card w-100 p-2 mb-2  d-inline-block">
                <div class="d-flex justify-content-between">
                    <h5 class="ml-3">Filters</h5>
                    <span class="btn btn-link" @click="showFilters = !showFilters">
                    <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
                    </span>
                </div>
                <div class="row" v-if="showFilters">
                    <div class="col-lg-12">
                        <form class="row">
                        <div class="col-md-6 col-lg-3">
                            <label for="filter" class="col-form-label">Date</label>
                            <datepicker v-model="logDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                        </div>
                        <div class="col-md-6 col-lg-3">
                            <button @click="clearFilter()" type="button" class="btn btn-secondary rounded top-2">Clear</button>
                            <button  @click="filelogs()" type="button" class="btn btn-primary rounded top-2">Filter</button>
                        </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-fluid" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <!-- <th 
                                    scope="col" 
                                    class="sort"
                                     >File</th> -->
                                <th 
                                    scope="col" 
                                    class="sort"
                                    >Date</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Action</th>           
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="logs.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in logs" :key="data.id">
                                <!-- <td>{{data.exportFile}}</td> -->
                                <td>{{moment(data.date).format("MM/DD/YYYY")}}</td>
                                <td class="text-center">
                                     <div class="dropdown">
                                        <button class="btn btn-warning rounded dropdown-toggle ml-2 mt-0" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-download"></i>  DOWNLOAD
                                        </button>
                                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item cursor-pointer" @click="exportToExcel(data.id,'excel')">EXCEL</a>
                                        <a class="dropdown-item cursor-pointer" @click="exportToExcel(data.id,'pdf')">PDF</a>
                                        </div>
                                                      

                                    </div>
                                    <!-- <button type="button" @click="exportToExcel(data.id)" class="btn btn-warning rounded ml-1"> <i class="fas fa-download"></i> EXPORT</button> -->
                                </td>
                                
                            </tr>
                            </tbody>
                        </table>
                        <!-- <nav aria-label="Page navigation example" v-if="!(logs.length == 0 && currentPage === 0)">
                            <ul class="pagination justify-content-center">
                                <li class="page-item" v-bind:class="{ disabled: currentPage === 0 }">
                                    <a class="page-link cursor-pointer"   @click="previous()">
                                        <i class="fa fa-angle-left"></i>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                </li>
                                <li class="page-item active"><a class="page-link">{{currentPage+1}}</a></li>
                                <li class="page-item" v-bind:class="{ disabled: this.logs.length < this.perPage }"  >
                                    <a class="page-link cursor-pointer" @click="next()">
                                        <i class="fa fa-angle-right"></i>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </li>
                            </ul>
                        </nav> -->
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="filelogs(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imsCusipComponent",
  components : {
    Datepicker
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        sortColumn: "",
        sortOrder: "ASC",
        logs : [],
        logDate : "",
        showFilters : false,
     
    };
  },
  methods: {
    searchLog(){
        this.filelogs();  
    },
    clearSearch(){
        this.searchValue = "";
        this.filelogs();  
    },
    clearFilter(){
        this.logDate = "";
        this.filelogs();
    },
    filelogs(){
      this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        var logDate = this.logDate ? "&date="+this.moment(this.logDate).utc().format('YYYY-MM-DD') : "";
        this.$http
        .get(
           config.baseUrlBidSide +
            "/bidwanted/export-list?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue+
            logDate,
            auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.logs = result.data.content;
          this.loading = false;
        }).catch(() => this.loading = false);
    },
    exportToExcel(fileId,fileType){
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      let data = {'id':fileId,"fileType":fileType}
      this.$http
        .post(
           config.baseUrlBidSide +
            "/bidwanted/export",data,
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });

    } 
   
  },
  mounted() {
    //this.logDate = this.moment().format("MM-DD-YYYY");
    this.filelogs()
  }
};
</script>
<style scoped>
.file-log .dropdown-menu {
    min-width: 7rem;
}
.file-log .dropdown-menu a {
    margin: 0px !important;
}
</style>